import { Component, Input, OnInit } from '@angular/core';
import { NavParams, PopoverController } from '@ionic/angular';
import { Employee } from 'src/app/_interfaces/employee';

@Component({
    selector: 'app-multiselect',
    templateUrl: './multiselect.page.html',
    styleUrls: ['./multiselect.page.scss'],
    standalone: false
})
export class MultiselectPage implements OnInit {


  @Input() employees: Employee[] = []

  public selectedIds: number[] = []

  constructor(
    private navParams: NavParams,
    private popoverCtrl: PopoverController
  ) { 
    
    this.employees = this.navParams.data.employees
    // this.selectedIds = this.employees.map(e => e.id)
  }

  ngOnInit() {
    
  }

  public select(employee:Employee){
    if(this.selectedIds.includes(employee.id)) this.selectedIds.splice(this.selectedIds.indexOf(employee.id), 1)
    else this.selectedIds.push(employee.id)
  }

  public async continue(){
    await this.popoverCtrl.dismiss({item: this.selectedIds})
  }


}
